<template>
  <v-card tile flat :class="$vuetify.theme.dark ? 'transparent' : 'transparent'" class="live-trade-details-card">
    <v-row dense class="no-gutters">
      <v-col cols="12">
        <v-sheet :class="$vuetify.theme.dark ? 'blue-darken-2' : 'transparent'" class="py-5 chips-wrapper">
          <div class="title mb-5">
            <span>Your Account Types</span>
          </div>
          <div class="account-types-buttons">
            <v-btn v-for="type in acctypes" :key="type?.id" outlined rounded color="#3F546B"
              class="text-capitalize mx-1" @click="handleAccountTypeClick(type)">
              {{ type.account_type_display }}
            </v-btn>
          </div>
        </v-sheet>
      </v-col>
    </v-row>

    <v-row dense class="mt-4">
      <v-col cols="12" sm="12" md="4" lg="6">
        <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search anything here ..." single-line solo
          hide-details class="mt-0"></v-text-field>
      </v-col>

      <v-col cols="6" sm="5" md="3" lg="3">
        <v-select v-model="selectedAccountType" :items="['All', ...acctypes]" item-text="account_type_display"
          item-value="id" append-icon="mdi-chevron-down" label="Account Types" class="custom-select mr-0 mt-0"
          solo></v-select>
      </v-col>

      <v-col cols="6" sm="5" md="3" lg="3">
        <v-select v-model="selectedCurrencyGroup" :items="['All', ...groups]" item-text="title" item-value="id"
          append-icon="mdi-chevron-down" label="Currency Group" class="custom-select mr-0 mt-0" solo></v-select>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12" sm="12">
        <v-card class="pa-3 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
          <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#1A2A3E' : '#F1F7FB'">
            <v-data-table :search="search" :headers="headers" :items="commissionSetup" :items-per-page="5">
              <template v-slot:item.ib_level="{ item }">
                {{ `L 1 - L ${total_ib_levels}` }}
              </template>

              <template v-slot:item.details="{ item }">
                <div class="d-flex align-center justify-center">
                  <v-dialog transition="scale-transition" origin="center center" max-width="820"
                    v-model="dialog[item?.id]" content-class="commission-tree">
                    <template v-slot:activator="{ on, attrs }">
                      <div class="links text-decoration-none mr-3">
                        <div v-bind="attrs" v-on="on">
                          <v-icon @click="handleSplitCommission(item)" class="ml-4" color="#039de9" small>
                            mdi-eye-outline
                          </v-icon>
                        </div>
                      </div>
                    </template>

                    <v-stepper v-model="e1" class="password-stepper admin-password-stepper">
                      <v-stepper-items>
                        <v-stepper-content step="1" class="pa-0">
                          <v-card class="deposit-form create-account-form"
                            :color="$vuetify.theme.dark ? 'transparent' : 'transparent'">
                            <v-row dense>
                              <v-card class="rounded-0 pa-7"
                                :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
                                <v-card-title class="pb-1 pt-0 justify-space-between font-weight-bold pl-3">
                                  <span>View Commission Split</span>
                                  <a target="_blank" class="text--green text-decoration-underline"
                                    href="https://www.youtube.com/watch?v=oRDRfikj2z8&t=1s">
                                    See Video
                                  </a>
                                </v-card-title>
                                <v-card-subtitle class="mt-0 pl-3 pb-4 text--ash tree-commission-label">
                                  <span> {{ item.account_type_display }}</span>
                                  <span> {{ item.currency_group_title }}</span>
                                  <span> L1 - L{{ total_ib_levels }}</span>
                                  <span> ${{ item.commission_rate }}</span>
                                </v-card-subtitle>
                                <v-card class="deposit-form px-3 py-4"
                                  :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
                                  <commission-split-table :splitData="viewrates?.commissionRate"
                                    :levelCounts="Number(viewrates?.total_ib_levels)" :tutorial="viewrates?.tutorial"
                                    v-model="commissionRate"
                                    @update:splitData="updateSplitData"></commission-split-table>
                                </v-card>
                                <v-card-actions>
                                  <v-row>
                                    <v-col cols="6">
                                      <v-btn @click="closeDialog(item)" :ripple="false" tile elevation="0"
                                        class="custom-btn px-10" color="#039de9" large :loading="loading">
                                        Close
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </v-card-actions>
                              </v-card>
                            </v-row>
                          </v-card>
                        </v-stepper-content>
                      </v-stepper-items>
                    </v-stepper>
                  </v-dialog>
                </div>
              </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { ASSACCTYPES__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";
import CommissionSplitTable from "./CommissionSplitTable.vue";

export default {
  name: "AccountTypes",

  components: {
    CommissionSplitTable
  },

  data() {
    return {
      search: "",
      selectedAccountType: null,
      selectedCurrencyGroup: null,
      dialog: {},
      loading: false,
      e1: 1,
      commissionRates: null,
      headers: [
        { text: "Account Type", align: "start", value: "account_type_display" },
        { text: "Group / Currency", value: "currency_group_title" },
        { text: "Level", value: "ib_level" },
        { text: "Total Commission", value: "commission_rate" },
        { text: "Detail", value: "details" },
      ],
    };
  },

  computed: {
    ...mapState("acctypes", [
      "acctypes",
      "groups",
      "commissionSetup",
      "total_ib_levels",
      "viewrates"
    ]),
  },

  watch: {
    selectedAccountType: {
      handler(newValue) {
        this.handleFilterChange();
      }
    },
    selectedCurrencyGroup: {
      handler(newValue) {
        this.handleFilterChange();
      }
    }
  },

  methods: {
    ...mapActions("acctypes", [
      ASSACCTYPES__ACTIONS.ASSIGNEDACCTYPES,
      ASSACCTYPES__ACTIONS.CURRENCYGROUPS,
      ASSACCTYPES__ACTIONS.COMRATRESTREE,
      ASSACCTYPES__ACTIONS.VIEWCOMRATRES,
      ASSACCTYPES__ACTIONS.UPDATECOMMISSIONRATES,
    ]),

    async handleAccountTypeClick(type) {
      this.selectedAccountType = type?.id;
    },

    async handleFilterChange() {
      const params = {
        account_type: this.selectedAccountType,
        currency_group: this.selectedCurrencyGroup,
      };

      if (this.selectedAccountType || this.selectedCurrencyGroup) {
        await Promise.all([
          this[ASSACCTYPES__ACTIONS.COMRATRESTREE](params),
        ]);
      }
    },

    async handleSplitCommission(item) {
      await this[ASSACCTYPES__ACTIONS.VIEWCOMRATRES]({
        account_type: item.account_type_id,
        currency_group: item.currency_group_id,
      })
    },

    updateSplitData(newData) {
      console.log(newData)
      this.viewrates.commissionRate = { ...newData };
    },

    async updateCommission(item) {
      this.loading = true;
      try {
        const res = await this[ASSACCTYPES__ACTIONS.UPDATECOMMISSIONRATES]({
          total_ib_levels: this.levelCounts,
          account_type: item.account_type_id,
          currency_group: item.currency_group_id,
          totalCommission: item.commission_rate,
          commissionRates: this.viewrates.commissionRate
        })

        if (res.status === 200) {
          this.closeDialog(item)
        }
      } catch (err) {
        console.log(err)
      } finally {
        this.loading = false;
      }
    },

    closeDialog(item) {
      this.$set(this.dialog, item?.id, false);
    },
  },

  async created() {
    await Promise.all([
      this[ASSACCTYPES__ACTIONS.ASSIGNEDACCTYPES](),
      this[ASSACCTYPES__ACTIONS.CURRENCYGROUPS](),
      this[ASSACCTYPES__ACTIONS.COMRATRESTREE]()
    ]);
  },
};
</script>